"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CharIcon = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _class, _class2, _temp;

var CharIcon = (0, _emotionTheming.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CharIcon, _React$Component);

  function CharIcon() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CharIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CharIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickHandler", function (flag) {
      return function () {
        _this.props.onClick(flag);
      };
    });
    return _this;
  }

  (0, _createClass2.default)(CharIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.character === this.props.character && nextProps.size === this.props.size && nextProps.className === this.props.className && nextProps.theme === this.props.theme);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          character = _this$props.character,
          size = _this$props.size,
          className = _this$props.className,
          theme = _this$props.theme;
      return _react.default.createElement("div", {
        role: "presentation",
        onMouseEnter: this.clickHandler(true),
        onMouseLeave: this.clickHandler(false),
        className: (0, _classnames.default)(_styles.default.root(theme, size), className)
      }, character);
    }
  }]);
  return CharIcon;
}(_react.default.Component), (0, _defineProperty2.default)(_class2, "propTypes", {
  character: _propTypes.default.string.isRequired,
  size: _propTypes.default.number.isRequired,
  onClick: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
}), (0, _defineProperty2.default)(_class2, "defaultProps", {
  className: undefined
}), _temp)) || _class;

exports.CharIcon = CharIcon;
var _default = CharIcon;
exports.default = _default;